import { AsyncPipe, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMap, MapMarker } from '@angular/google-maps';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { MapSearchPropertyMenuComponent } from './components/map-search-property-menu/map-search-property-menu.component';
import { MapSearchPropertyComponent } from './components/map-search-property/map-search-property.component';
import { HomePageRoutingModule } from './home-routing.module';
import { HomePageComponent } from './home.page';

@NgModule({
  declarations: [HomePageComponent, MapSearchPropertyMenuComponent, MapSearchPropertyComponent],
  imports: [MiscModule, FormsModule, IonicModule, HomePageRoutingModule, GoogleMap, NgClass, AsyncPipe, MapMarker]
})
export class HomePageModule {}
